import { WrapperAmplitudeCompanyTab } from "components/company/v3/WrapperCompany";
import BrazilianPageLayout from "components/company/v3/layouts/BrazilianPageLayout";
import BrazilianQuotesBox from "components/company/v3/brazilian/boxes/BrazilianQuotesBox";
import { CompanyQuotesTabEnum } from "components/company/v3/menu/enums";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { format } from "util";
import BrazilianIssuerSeo from "components/company/v3/seo/BrazilianIssuerSeo";
import { useIntl } from "react-intl";
import useSelfie from "lib/hooks/useSelfie";
import IssuerHeaderByTickerSymbol from "components/issuers/IssuerHeaderByTickerSymbol";
import { ISecurityCountry } from "types/graphqlTypes";

interface BrazilianQuotesPageProps {
  tickerSymbol: string | null;
}

const BrazilianQuotesPage: NextPage<BrazilianQuotesPageProps> = function BrazilianQuotesPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<CompanyQuotesTabEnum>(Object.values(CompanyQuotesTabEnum)).withDefault(
      CompanyQuotesTabEnum.QUOTE,
    ),
  );
  const viewer = useSelfie();
  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();

  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <BrazilianPageLayout tickerSymbol={normalizedTickerSymbol}>
      <WrapperAmplitudeCompanyTab category="Ações" tab={tab} tickerSymbol={normalizedTickerSymbol}>
        <>
          <BrazilianIssuerSeo
            tickerSymbol={normalizedTickerSymbol}
            title={intl.formatMessage({
              defaultMessage: "Cotação",
              id: "d+IfD/",
              description: "Título da página - SEO",
            })}
            description={intl.formatMessage({
              defaultMessage:
                "Cotação atualizada, gráfico histórico de preços, retorno anual e valorização acumulada nos últimos anos.",
              id: "3L4psL",
              description: "Descrição da página de cotação - SEO",
            })}
          />
          {!viewer && (
            <IssuerHeaderByTickerSymbol
              country={ISecurityCountry.Br}
              tickerSymbol={normalizedTickerSymbol}
              className="pb-6"
              title={intl.formatMessage({ defaultMessage: "Cotação", id: "zV6SED" })}
              description={intl.formatMessage({
                defaultMessage: "Gráfico histórico de cotação e retorno anual dos últimos anos",
                id: "SaNBkr",
              })}
            />
          )}
          <BrazilianQuotesBox
            key={format("quotes/%s/%s", tickerSymbol, tab)}
            tickerSymbol={normalizedTickerSymbol}
            tab={tab}
            onChangeTab={setTab}
          />
        </>
      </WrapperAmplitudeCompanyTab>
    </BrazilianPageLayout>
  );
};

BrazilianQuotesPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default BrazilianQuotesPage;
